<template>
  <div class="wrapper clickable" @click="displayMedia(true)">
    <img :src="thumbnail" class="cover" fluid/>
    <div class="icon">
      <i class="fas fa-play fa-3x"></i>
    </div>

    <b-modal v-model="showModal"
             :title="videoName"
             centered
             size="lg"
             hide-footer 
             no-close-on-backdrop>

      <div class="embed-responsive embed-responsive-16by9">
        <video id="modalVideo" ref="modalVideo" controls="false">
          <source :src="url" />
        </video>      
      </div>
    </b-modal>
  </div>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      showModal: false
    }
  },
  computed: {
    url () {
      if (this.item.media[0]) {
        return this.item.media[0].url
      }
      return ''
    },
    thumbnail () {
      return this.item.media[0].thumbnail.url
    },
    videoName () {
      if (this.item.media[0]) {
        return this.item.media[0].name
      } else {
        return ''
      }
    },
    modalVideo () {
      return this.$refs.modalVideo
    }
  },
  watch: {
    showModal: function (val) {
      if (!val) {
        this.modalVideo.pause()
        this.modalVideo.currentTime = 0
      }
    }
  },
  methods: {
    displayMedia (show) {
      this.showModal = show
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'assets/stylesheets/main.scss';

.wrapper {
  height: 8rem;
  width: 15rem;
  position: relative;
  overflow: hidden;
  margin-right: $spacing-sm;
  flex: 0 0 auto;
  justify-content:center;
  align-items: center;
  border: 1px solid rgba(0, 0, 0, 0.125);
  border-radius: 0.25rem;
}

div.wrapper img {
  position: relative;
  top: -1px;
  left: -1px;
}

.cover {
  object-fit: fill;
  width: 15rem;
  height: 8rem;
}

.icon {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate( -50%, -50% );
  z-index: 500;
  color: $medium-grey;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/client/items/video.vue